<button mat-icon-button class="sh-id-button" [disabled]="disabled()" (click)="identifyDevice($event)">
	<prism-icon
		class="sh-id-button-icon"
		[class.sh-identifying]="isIdentifying()"
		[icon]="isIdentifying() ? 'stop' : 'sh-id-nobox'"
	></prism-icon>
</button>
